import { computed } from 'vue'
import { useRoute } from '#app/composables/router'

export function useLocale() {
  const route = useRoute()
  return computed(() => String(route.params.locale))
}
